import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import { injectStripe } from 'react-stripe-elements';
import { bindActionCreators, compose } from 'redux';

import { 
  getActiveAgencyUser,
  getPaymentMethodsForAgency,
  getAllPaymentMethodsForAgency 
} from '../../shared/redux/selectors';

import {
  createPaymentMethod,
  updateAgency
} from '../../shared/redux/entities/actions';


function mapStateToProps(state){
  const activeUser = getActiveAgencyUser(state);

  return {
    activeUser:activeUser,
    activeAgency:get(state,['entities','agencies',activeUser.agencyId],{}),
    allPaymentMethods:getAllPaymentMethodsForAgency(state,activeUser.agencyId),
    activePaymentMethods:getPaymentMethodsForAgency(state,activeUser.agencyId)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    createPaymentMethod,
    updateAgency
  },dispatch);
}

export default compose(
  injectStripe,
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AgencyCreatePaymentMethod/connect.js